'use client';

const TOAST_NOTIFICATION_ANIMATION_DURATION = 400;
const TOAST_NOTIFICATION_DISMISSAL_DURATION = 6e3 + TOAST_NOTIFICATION_ANIMATION_DURATION;
export {
  TOAST_NOTIFICATION_ANIMATION_DURATION,
  TOAST_NOTIFICATION_DISMISSAL_DURATION
};
